<template>
    <div class="events">
 
                      <b-card lazy>
                          
                        <div v-show="hide_events===false">
                          <div class="input-group mb-3" id="search_string">
                          <input style="border-radius: 0rem;" type="text"   v-model="searchString.name" v-on:keyup="searchEvent()" class="form-control" :placeholder="$t('type')"  :aria-label="$t('search')">
                            <div class="input-group-append">
                              <button @click="searchEvent()" class="btn btn-primary" id="users-search-button"><i class="fa fa-search"></i></button>
                              <a class="btn btn-success" href="#" v-on:click="advancedSearch=!advancedSearch"><i class="fa fa-cog fa-1x"></i></a>
                            </div>
                          </div>
                            <b-card v-show="advancedSearch"  class="mb-2" >
                          Статус мероприятия
                          <b-form-select v-model="searchString.event_status" class="mb-3">
                            <option value="">{{ $t('all') }} </option>
                            <option value="0">{{ $t('nocoll') }} </option>
                            <option value="1" >{{ $t('coll') }} </option>
                          </b-form-select>
                              Тип участия
                                                        <b-form-select v-model="searchString.participation_type" class="mb-3">
                            <option value="">{{ $t('all') }} </option>
                            <option value="0">{{ $t('in') }} </option>
                            <option value="1" >{{ $t('out') }} </option>
                             <option value="2">{{ $t('inout') }} </option>
                          </b-form-select>
                              Направления: 
                              <v-select :filterable="false" :options="areas" label="name" taggable multiple  v-model="searchString.area_of_interest" @search="getOptions">
                                  <template slot="no-options">
                                      Ничего не найдено
                                  </template>
                                  <template slot="option" slot-scope="option">
                                      <div class="d-center">
                                          {{ option.name }}
                                      </div>
                                  </template>
                                  <template slot="selected-option" slot-scope="option">
                                      <div class="selected d-center" >
                                          {{ option.name }}
                                      </div>
                                  </template>
                              </v-select>
                              Организация: 
                              <v-select :filterable="false" :options="organizations" label="name" taggable  v-model="searchString.organisation" @search="getOrganization">
                                  <template slot="no-options">
                                      Ничего не найдено
                                  </template>
                                  <template slot="option" slot-scope="option">
                                      <div class="d-center">
                                          {{ option.name }}
                                      </div>
                                  </template>
                                  <template slot="selected-option" slot-scope="option">
                                      <div class="selected d-center" >
                                          {{ option.name }}
                                      </div>
                                  </template>
                              </v-select>

                          </b-card>
                        </div>
                        <div class="row"> 
                            <b-navbar style="position: initial;" toggleable="lg" >
                            <b-navbar-toggle target="nav_collapse1"></b-navbar-toggle>
                            <b-collapse is-nav id="nav_collapse1">
                      <b-tabs pills  >
                        <b-tab class="nav-item" @click="hide_events=false; tab = 'all'" :title="$t('all')">
                        </b-tab>
                        <b-tab class="nav-item" @click="hide_events=false; tab = 'conferences'" :title="$t('conf')">
                        </b-tab>
                        <b-tab class="nav-item" @click="hide_events=false; tab = 'competitions'" :title="$t('conc')">
                        </b-tab>
                        <b-tab class="nav-item" @click="hide_events=false; tab = 'periods'" :title="$t('pered')" >
                        </b-tab>
                         <b-tab class="nav-item" v-if="$auth.check()" @click="hide_events=false; tab = 'favorites'">
                          <template slot="title">
                            <i class="px-nav-icon fa fa-star"></i> {{ $t('is') }} 
                          </template>
                        </b-tab>
                         <b-tab v-if="$auth.check()" @click="hide_events=false; tab = 'myevents'">
                          <template slot="title">
                            <i class="px-nav-icon fa fa-home" ></i>{{ $t('my') }} 
                          </template>
                        </b-tab>
                        <b-tab class="nav-item" v-if="$auth.check()" @click="hide_events=true; advancedSearch=false">
                          <template slot="title" >
                            <i class="px-nav-icon fa fa-plus"></i> Новый вид деятельности 
                          </template>
                            <newEvent isNewRecord></newEvent>
                        </b-tab>
                        
                      </b-tabs>
                            </b-collapse>
                            </b-navbar>
                            
                        </div>
                             <EventList v-show="hide_events===false" :tab="tab" :searchString="string" ref="EventList"></EventList> 
                    </b-card> 

    </div>
</template>



<i18n>
{
  "en": {
    "type": "Start typing any name",
    "adv": "Advanced search",
    "search": "Search",
    "all": "All",
    "conf": "Conferences",
    "conc": "Contests",
    "pered": "Periodicals",       
    "is": "Favorites",        
    "my": "My events",        
    "new": "New event",        
    "in": "Full time",        
    "out": "In absentia",
    "inout": "Full time with absentee participation",     
    "open": "Registration is now open - yes, no",        
    "data": "Dates - the range of choices",
    "place": "Venue - Select city",
    "area": "Interests - select from the available",
    "ent": "Type word and press enter",
    "coll":  "Is collecting materials",
    "nocoll": "Collection of materials is over"
        
  },
  "ru": {
    "type": "Начните вводить любое название",
    "adv": "Расширенный поиск",
    "search": "Поиск",
    "all": "Все",
    "conf": "Конференции",
    "conc":  "Конкурсы",
    "pered": "Периодические издания",       
    "is": "Избранное",        
    "my": "Мои мероприятия",        
    "new": "Новое мероприятие",        
    "in": "Очное",        
    "out": "Заочное",
    "inout": "Очное с заочным участием",     
    "open": "Открыта регистрация - да, нет",        
    "data": "Дата проведения - диапазон выбора",
    "place": "Место проведения - выбор города",
    "area": "Область интересов - выбор из имеющихся",
    "ent": "Напишите слово и нажмите enter",
    "coll":  "Идёт сбор материалов",
    "nocoll": "Сбор материалов окончен"
   }
}
</i18n>




















<script>
      const debounce = function (f, ms) {
        let timer = null;
        return function (...args) {
            const onComplete = () => {
                f.apply(this, args);
                timer = null;
            }
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(onComplete, ms);
        };
    }
    import EventList from './event_list'
    import newEvent from './settings/settings'
    import vSelect from 'vue-select'
    export default {
      name: 'events',
      components: {
        EventList,
        newEvent,
        vSelect
      },
      data: function () {
        return {
            hide_events:false,
            advancedSearch: false,
            searchString: {
                name: '',
                participation_type:'',
                organisation: '',
                area_of_interest:'',
                event_status:''
            },
            tab: 'all',
            areas: [],
            organizations: [],
        }
      },
      computed: {
            'string': function () {
                var output = {};
                Object.assign(output, this.searchString)
                output.area_of_interest = JSON.stringify(output.area_of_interest)
                return output;
            }
        },
      methods: {
            searchEvent() {
                this.$refs.EventList.search();
            },
            getOptions(search, loading) {
                loading(true)
                this.search(loading, search, this);
            },
            search: debounce(function (loading, search, vm) {
                vm.$http.get('event/get-areas?q=' + search)
                        .then(response => vm.$set(vm, 'areas', response.data.results));
                loading(false)
            }, 350),
            getOrganization(search, loading) {
                loading(true)
                this.searchOrganization(loading, search, this);
            },
            searchOrganization: debounce(function (loading, search, vm) {
                vm.$http.get('user/get-organization?q=' + search)
                        .then(response => vm.$set(vm, 'organizations', response.data.results));
                loading(false)
            }, 350),
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #search_string {
      -moz-box-shadow:0 0 20px 15px #FFF;
      -webkit-box-shadow:0 0 20px 15px #FFF;
      box-shadow:0 0 20px 15px #FFF;
      position: static;
      position: sticky; 
      top: 61px; 
      z-index: 100;
  }
  .navbar-light .navbar-toggler {
          margin-left: auto;
  }

</style>
<style>
    .collapsing {
      z-index: 1005;
      position:fixed !important;
  }
      .navbar-collapse.collapse.show .nav-pills, .navbar-collapse.collapsing .nav-pills {
      display: block;
      z-index: 1005;
      position:absolute !important;
      background-color: white;

      border: 1px solid #f2f2f2;
  }
  .navbar-collapse.collapse.show .nav-pills .nav-item, .navbar-collapse.collapsing .nav-pills .nav-item {
    margin-left: 0px;
}
  </style>